import React, {useState, useEffect} from 'react';
import {connect} from "react-redux";
import {
    resetState,
    setSelectedPackage,
 init, execute, steps
} from "./IdfSurfingPackageExpansionSlice"
import Header from "app/Components/Block/IdfSaleBlock/Constans/Header";
import SummaryStep from "app/Components/Block/IdfSurfingPackageExpansionBlock/steps/SummaryStep";
import SelectionStep from "app/Components/Block/IdfSurfingPackageExpansionBlock/steps/SelectionStep";



const IdfSurfingPackageExpansion = (props) => {

  useEffect(() => {
    if (props.userData?.loginData?.userDetails?.contactNumber !== undefined && !props.idfSurfingPackageExpansion.loaded) {
      initProcess();
    }
    return () => {
      props.resetState();
    };
  }, [props.userData?.loginData?.userDetails]);

  const initProcess = async () => {
    await props.init(props.userData?.loginData?.userDetails?.contactNumber);
  };

    function renderStep() {
        switch (props.idfSurfingPackageExpansion.currentStep) {
            case steps.SELECTION:
                return <SelectionStep iContent={props.iContent}/>
            case steps.SUMMARY:
                return <SummaryStep/>
            default:
                return <SelectionStep iContent={props.iContent}/>
        }
    }
    function isSummaryStep() {
        return props.idfSurfingPackageExpansion.currentStep === steps.SUMMARY;
    }
    return (
       <>
         <Header onClickBack={() => window.history.back()} hideBackButton={props.idfSurfingPackageExpansion.currentStep === steps.SUMMARY}/>
         {props.idfSurfingPackageExpansion.loaded &&
           <div className={`idf-surfing-package-expansion-main-container ${isSummaryStep() ? 'white-background' : ''}`}>
               {renderStep()}
           </div>
         }
       </>
    );
}

const mapStateToProps = (state) => {
    return {
        idfSurfingPackageExpansion: state.IdfSurfingPackageExpansion,
        userData: state.authentication
    }
};

const mapDispatchToProps = {
    resetState,
    setSelectedPackage,
    init,
    execute
};

export default connect(mapStateToProps, mapDispatchToProps)(IdfSurfingPackageExpansion);
